import React from 'react';
import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { SuggestedFollowee } from 'js/core_post_webpack/models/user';
import AvatarBase, { Name as NameBase } from './shared/Avatar';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import { ImpressionEntity } from 'js/utils/impressions/watchImpressions';
import {
  getSocialImpressionSource,
  serializeUserSuggestionScoringMetadata,
} from './ImpressionHelper';
import { LinkButton } from 'js/social/shared/design_system/LinkButton';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const UserSection = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  gap: 8px;
`;

const Avatar = styled(AvatarBase)`
  flex-shrink: 0;
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const University = styled(Body)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  color: $ds-gray-dark;
  font-size: 12px;
  line-height: 18px;
`;

const Name = styled(NameBase)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 500;
  color: $ds-black;
`;

const IMPRESSION_PAGE = 'home';
const IMPRESSION_SECTION = 'sugg';

interface Props {
  user: SuggestedFollowee;
  followUser: (id: number) => void;
  scoring?: { [key: string]: any };
}

const SuggestedUserCard: React.FC<Props> = ({ user, followUser, scoring }) => {
  return (
    <Container>
      <UserSection>
        <ImpressionWatcher
          source={getSocialImpressionSource(
            IMPRESSION_PAGE,
            IMPRESSION_SECTION,
            'prof-p',
          )}
          entity_type={ImpressionEntity.User}
          entity_id={user.id}
        >
          <Avatar
            fullName={user.display_name as string}
            photoUrl={user.photo}
            profileUrl={user.url}
          />
        </ImpressionWatcher>
        <UserInfo>
          <ImpressionWatcher
            source={getSocialImpressionSource(
              IMPRESSION_PAGE,
              IMPRESSION_SECTION,
              'prof-n',
            )}
            entity_type={ImpressionEntity.User}
            entity_id={user.id}
            extra={{
              scoring: serializeUserSuggestionScoringMetadata(scoring),
            }}
          >
            <Name href={user.url}>
              {user.display_name || user.first_name + ' ' + user.last_name}
            </Name>
          </ImpressionWatcher>
          {user.department?.university?.name && (
            <University>{user.department?.university?.name}</University>
          )}
          <LinkButton onClick={() => followUser(user.id)}>Follow</LinkButton>
        </UserInfo>
      </UserSection>
    </Container>
  );
};

export default SuggestedUserCard;
